module.exports = __webpack_public_path__ + "img/ساده 2.71102f77.jpg";